import type { ComponentProps } from "react"
import Separator from "@/v2-ui/separator"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipLink } from "@/v2-backoffice-client/components/link"
import {
  FENERUM_ACCOUNT_BASE_URL,
  HUBSPOT_BASE_URL,
} from "@/v2-backoffice-client/constants"
import type { LicenseAccountFragment } from "@/v2-backoffice-client/license/account/__types__/license.account.fragment"

export type LicenseAccountViewToolbarProps = ComponentProps<"div"> & {
  account: LicenseAccountFragment | null | undefined
}

// The account is Fenerum's — the deep link goes to the system that owns it
// (credit/resend/dunning all happen there). The other two jump to the matched
// customer's panel and HubSpot record; an unmatched account has neither.
function LicenseAccountViewToolbar(props: LicenseAccountViewToolbarProps) {
  const { account, ...viewSheetToolbarProps } = props
  if (!account) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <TooltipLink
        variant="ghost"
        isStacked
        iconSrc="bank"
        content="Open this billing account in Fenerum"
        to={`${FENERUM_ACCOUNT_BASE_URL}/${account.ExternalAccountUuid}/`}
      >
        Fenerum
      </TooltipLink>

      {account.ExternalCustomerId && (
        <>
          <Separator orientation="vertical" />

          <TooltipLink
            variant="ghost"
            isStacked
            iconSrc="expand"
            content="Open the matched customer's panel"
            to={`>>?v=customer:${account.ExternalCustomerId}`}
          >
            Customer
          </TooltipLink>

          <TooltipLink
            variant="ghost"
            isStacked
            iconSrc="hubspot"
            content="Open the matched customer in HubSpot"
            to={`${HUBSPOT_BASE_URL}/${account.ExternalCustomerId}`}
          >
            HubSpot
          </TooltipLink>
        </>
      )}
    </ViewSheet.Toolbar>
  )
}

export default LicenseAccountViewToolbar
